export default __webpack_public_path__ + "static/media/SIW200H_M075_105_W10.0d0ca83f.webp";